import { render, staticRenderFns } from "./DocumentPreviewDialog.vue?vue&type=template&id=6c36663e&scoped=true"
import script from "./DocumentPreviewDialog.vue?vue&type=script&lang=js"
export * from "./DocumentPreviewDialog.vue?vue&type=script&lang=js"
import style0 from "./DocumentPreviewDialog.vue?vue&type=style&index=0&id=6c36663e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c36663e",
  null
  
)

export default component.exports